import axios from 'axios';

axios.defaults.timeout = 180000;
const Api = {
    /**
     * @param url
     * @param data
     * @return {Promise<AxiosResponse<any>>}
     */
    get(url, data = {}) {
        const params = Object.assign({}, data);
        params.timestamp = Date.now();

        return axios({
            method: 'get',
            url,
            params
        })
            .then(response => response.data)
            .then((response) => {
                if (response.status === 'error') {
                    if (response.errorMessage) {
                        if (response.errorMessage.redirect) {
                            window.location = response.errorMessage.redirect;
                        }
                    }
                }
                return response;
            })
            .catch((error) => {
                // eslint-disable-next-line
            });
    },
    /**
     * @param {string} url
     * @param {object|FormData} data
     * @return {Promise<AxiosResponse<any>>}
     */
    post(url, data) {
        let formData;

        if (data instanceof FormData) {
            formData = data;
        } else {
            const params = Object.assign({}, data);
            // params.timestamp = Date.now();
            formData = this.makeFormData(params);
        }

        return axios.post(url, formData)
            .then(response => response.data)
            .then((response) => {
                if (response.status === 'error') {
                    if (response.errorMessage) {
                        if (response.errorMessage.redirect) {
                            window.location = response.errorMessage.redirect;
                        }
                    }
                }
                return response;
            })
            .catch((error) => {
                // eslint-disable-next-line
            });
    },
    makeFormData(data) {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            const item = data[key];
            if (Array.isArray(item)) {
                item.forEach((value) => {
                    formData.append(`${key}[]`, value);
                });
            } else {
                formData.append(key, data[key]);
            }
        });

        return formData;
    }
};

export default Api;
